(function () {
  'use strict';

  var formEl = document.getElementById('wsa-form');
  if (!formEl) return;

  var COMPANY_ID = formEl.dataset.klaviyoCompanyId || 'TH64eF';
  var LIST_ID_NEW_ACCOUNTS = formEl.dataset.klaviyoListId || 'UPAD7B';
  var LIST_ID_ORDERING_CONTACTS = formEl.dataset.klaviyoListIdOrdering || 'Rq2cBt';
  var REVISION = '2024-10-15';
  var SUBSCRIBE_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var EVENT_URL = 'https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID;

  /* ── Spam guard: the hidden company_website honeypot, plus a minimum time between page load
     and submit. A bot that trips either one sees the normal confirmation, but nothing is sent
     to Klaviyo (no profile, no team alert, no confirmation email to a scraped address). ── */
  var FORM_READY_AT = Date.now();
  var MIN_FILL_MS = 4000;
  function looksLikeBot() {
    var trap = formEl.querySelector('input[name="company_website"]');
    var reason = (trap && trap.value) ? 'honeypot filled' : (Date.now() - FORM_READY_AT < MIN_FILL_MS ? 'submitted too fast' : '');
    if (reason && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') console.debug('Wholesale form spam guard:', reason);
    return !!reason;
  }

  /* ── Fail-safe submit helpers ──
     Privacy tools block a.klaviyo.com (AdGuard Tracking Protection, Firefox strict / private windows,
     Pi-hole's default list), and then the request used to be lost. Now: subscribe, then the event even if
     the subscribe failed, then a backup copy through Shopify's own /contact form on this domain (lands in
     info@). The error message only shows if all three fail. ── */
  var IS_DEV = !!(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');

  // E.164 only for a real North American number (area code and exchange can't start with 0 or 1, no N11
  // area codes). Anything else stays off the profile; the raw value still goes on the event.
  function toE164(raw) {
    var d = String(raw || '').split(/x|ext/i)[0].replace(/\D/g, ''); // drop an extension ("x123", "ext. 4")
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(d) || /^\d11/.test(d)) return '';
    return '+1' + d;
  }

  // DEV only (unpublished theme): ?test_backup=1 makes the Klaviyo calls fail so the backup path can be tested by hand.
  var FORCE_BACKUP = IS_DEV && /[?&]test_backup=1/.test(location.search);

  function postKlaviyo(url, payload) {
    if (FORCE_BACKUP) return Promise.reject(new Error('test_backup: Klaviyo forced off'));
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok) return res;
      return res.text().then(function (t) { throw new Error('HTTP ' + res.status + (t ? ' ' + t.slice(0, 160) : '')); });
    });
  }

  // Shopify's /contact needs an hCaptcha token, which Shopify's own script adds only when a real contact form is
  // submitted natively. So the backup fills the hidden {% form 'contact' %} in this section and submits it. The page
  // navigates; Shopify sends it back with ?contact_posted=true and the confirmation shows on load (below).
  var BACKUP_FORM_ID = 'wsa-backup-form';
  var BACKUP_FLAG = 'wholesaleBackupPending';
  function submitBackupForm(fields) {
    var f = document.getElementById(BACKUP_FORM_ID);
    if (!f) return false;
    Object.keys(fields).forEach(function (k) { if (f.elements[k]) f.elements[k].value = fields[k]; });
    // Shopify binds its captcha to a contact form on the first focus inside it, and cancels any submit before that.
    f.elements['contact[body]'].dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
    var started = Date.now();
    (function submitWhenBound() {
      if (f.dataset.hcaptchaBound || f.dataset.recaptchaBound || Date.now() - started > 8000) {
        if (f.requestSubmit) {
          f.requestSubmit();
        } else {
          f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } else {
        setTimeout(submitWhenBound, 150);
      }
    })();
    return true;
  }

  function sendBackup(subject, name, email, phone, lines) {
    var fields = { 'contact[Subject]': subject, 'contact[name]': name, 'contact[email]': email, 'contact[phone]': phone, 'contact[body]': lines.join('\n') };
    // Keep our own copy: if Shopify shows its "not a robot" check, the visitor comes back here and we resubmit.
    try { sessionStorage.setItem(BACKUP_FLAG, JSON.stringify({ name: name, fields: fields, tries: 1, at: Date.now() })); } catch (e) {}
    if (!submitBackupForm(fields)) return Promise.reject(new Error('backup form missing'));
    return new Promise(function (resolve, reject) {
      // The page navigates on success. Still here after 25s means the backup didn't go out either.
      setTimeout(function () {
        try { sessionStorage.removeItem(BACKUP_FLAG); } catch (e) {}
        reject(new Error('contact form did not submit (captcha)'));
      }, 25000);
    });
  }

  // Last resort: the visitor's own mail app, with the whole request already written.
  function mailtoLink(subject, lines) {
    var body = lines.join('\n');
    if (body.length > 1800) body = body.slice(0, 1800) + '\n...';
    return 'mailto:wholesale@magnoliacoffeeco.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function readBackupFlag() {
    try {
      var raw = sessionStorage.getItem(BACKUP_FLAG);
      if (raw) sessionStorage.removeItem(BACKUP_FLAG);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  /* ── UTM + Referrer capture ── */
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var utmMap = {
      'utm_source': 'wsa-utm-source',
      'utm_medium': 'wsa-utm-medium',
      'utm_campaign': 'wsa-utm-campaign',
      'utm_content': 'wsa-utm-content',
      'utm_term': 'wsa-utm-term'
    };

    Object.keys(utmMap).forEach(function (key) {
      var input = document.getElementById(utmMap[key]);
      if (input) input.value = params.get(key) || '';
    });

    var refInput = document.getElementById('wsa-referrer');
    if (refInput) refInput.value = document.referrer || '';
  });

  /* ── Shipping address toggle ── */
  var shippingSameCheckbox = document.getElementById('wsa-shipping-same');
  var shippingFields = document.getElementById('wsa-shipping-fields');

  if (shippingSameCheckbox && shippingFields) {
    shippingSameCheckbox.addEventListener('change', function () {
      if (this.checked) {
        shippingFields.classList.remove('is-visible');
        shippingFields.querySelectorAll('[data-conditional-required]').forEach(function (f) {
          f.removeAttribute('required');
          f.classList.remove('is-invalid');
        });
      } else {
        shippingFields.classList.add('is-visible');
        shippingFields.querySelectorAll('[data-conditional-required]').forEach(function (f) {
          f.setAttribute('required', '');
        });
      }
    });
  }

  /* ── Ordering contact toggle ── */
  var orderingSameCheckbox = document.getElementById('wsa-ordering-same');
  var orderingFields = document.getElementById('wsa-ordering-fields');

  if (orderingSameCheckbox && orderingFields) {
    orderingSameCheckbox.addEventListener('change', function () {
      if (this.checked) {
        orderingFields.classList.remove('is-visible');
        orderingFields.querySelectorAll('[data-conditional-required-ordering]').forEach(function (f) {
          f.removeAttribute('required');
          f.classList.remove('is-invalid');
        });
      } else {
        orderingFields.classList.add('is-visible');
        orderingFields.querySelectorAll('[data-conditional-required-ordering]').forEach(function (f) {
          f.setAttribute('required', '');
        });
      }
    });
  }

  /* ── Tax-exempt toggle ── */
  var taxRadios = document.querySelectorAll('input[name="tax_exempt"]');
  var taxNote = document.getElementById('wsa-tax-note');

  taxRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (taxNote) {
        if (this.value === 'Yes') {
          taxNote.classList.add('is-visible');
        } else {
          taxNote.classList.remove('is-visible');
        }
      }
    });
  });

  /* ── Account type pre-fill from business type ── */
  var BUSINESS_TYPE_TO_ACCOUNT_TYPE = {
    'Specialty Food / Grocery Store': 'Retail',
    'Gift / Lifestyle Boutique': 'Retail',
    'Café / Espresso Bar': 'Bulk',
    'Coffee Truck / Cart': 'Both', // trailers and carts brew, and both 10/2026 trailer leads asked for retail too
    'Restaurant': 'Bulk',
    'Hotel / B&B': 'Bulk',
    'Co-working Space': 'Bulk'
  };

  var businessTypeSelect = document.getElementById('wsa-business-type');
  var accountTypeManuallySet = false;

  function setAccountType(value) {
    var radio = formEl.querySelector('input[name="account_type"][value="' + value + '"]');
    if (radio) {
      radio.checked = true;
      updateVolumeVisibility(value);
    }
  }

  if (businessTypeSelect) {
    businessTypeSelect.addEventListener('change', function () {
      if (accountTypeManuallySet) return;
      var defaultType = BUSINESS_TYPE_TO_ACCOUNT_TYPE[this.value];
      if (defaultType) setAccountType(defaultType);
    });
  }

  /* ── Account type → volume visibility ── */
  var retailVolumeFields = document.getElementById('wsa-retail-volume-fields');
  var bulkVolumeFields = document.getElementById('wsa-bulk-volume-fields');

  function updateVolumeVisibility(accountType) {
    var showRetail = accountType === 'Retail' || accountType === 'Both';
    var showBulk = accountType === 'Bulk' || accountType === 'Both';

    if (retailVolumeFields) {
      retailVolumeFields.classList.toggle('is-visible', showRetail);
      retailVolumeFields.querySelectorAll('[data-conditional-required-retail-volume]').forEach(function (f) {
        if (showRetail) {
          f.setAttribute('required', '');
        } else {
          f.removeAttribute('required');
          f.classList.remove('is-invalid');
        }
      });
    }

    if (bulkVolumeFields) {
      bulkVolumeFields.classList.toggle('is-visible', showBulk);
      bulkVolumeFields.querySelectorAll('[data-conditional-required-bulk-volume]').forEach(function (f) {
        if (showBulk) {
          f.setAttribute('required', '');
        } else {
          f.removeAttribute('required');
          f.classList.remove('is-invalid');
        }
      });
    }
  }

  var accountTypeRadios = document.querySelectorAll('input[name="account_type"]');
  accountTypeRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      accountTypeManuallySet = true;
      updateVolumeVisibility(this.value);
    });
  });

  /* ── Validation ── */
  function clearErrors() {
    formEl.querySelectorAll('.is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
  }

  function validateForm() {
    clearErrors();
    var valid = true;
    var requiredFields = formEl.querySelectorAll('[required]');

    requiredFields.forEach(function (field) {
      if (!field.value.trim()) {
        field.classList.add('is-invalid');
        valid = false;
      }
    });

    var emailFields = formEl.querySelectorAll('input[type="email"][required]');
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    emailFields.forEach(function (field) {
      if (field.value.trim() && !emailPattern.test(field.value.trim())) {
        field.classList.add('is-invalid');
        valid = false;
      }
    });

    var phoneFields = formEl.querySelectorAll('input[type="tel"][required]');
    phoneFields.forEach(function (field) {
      if (field.value.trim()) {
        var digits = field.value.replace(/\D/g, '');
        if (digits.length < 10) {
          field.classList.add('is-invalid');
          valid = false;
        }
      }
    });

    var zipField = document.getElementById('wsa-business-zip');
    if (zipField && zipField.value.trim()) {
      var zipPattern = /^\d{5}(-\d{4})?$/;
      if (!zipPattern.test(zipField.value.trim())) {
        zipField.classList.add('is-invalid');
        valid = false;
      }
    }

    var shippingZip = document.getElementById('wsa-shipping-zip');
    if (shippingZip && shippingZip.hasAttribute('required') && shippingZip.value.trim()) {
      var zipPattern2 = /^\d{5}(-\d{4})?$/;
      if (!zipPattern2.test(shippingZip.value.trim())) {
        shippingZip.classList.add('is-invalid');
        valid = false;
      }
    }

    var taxChecked = formEl.querySelector('input[name="tax_exempt"]:checked');
    if (!taxChecked) {
      var taxGroup = document.getElementById('wsa-tax-group');
      if (taxGroup) taxGroup.classList.add('is-invalid');
      valid = false;
    }

    var accountTypeChecked = formEl.querySelector('input[name="account_type"]:checked');
    if (!accountTypeChecked) {
      var acctGroup = document.getElementById('wsa-account-type-group');
      if (acctGroup) acctGroup.classList.add('is-invalid');
      valid = false;
    }

    if (!valid) {
      var firstInvalid = formEl.querySelector('.is-invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (firstInvalid.focus) firstInvalid.focus();
      }
    }

    return valid;
  }

  /* ── Helpers ── */
  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function showError(msg) {
    var errEl = document.getElementById('wsa-form-error');
    if (errEl) {
      errEl.innerHTML = msg;
      errEl.removeAttribute('hidden');
      errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hideError() {
    var errEl = document.getElementById('wsa-form-error');
    if (errEl) errEl.setAttribute('hidden', '');
  }


  /* ── Build Klaviyo subscription payload ── */
  function buildSubscriptionPayload(listId, profileAttrs) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Wholesale Account Application',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };
  }

  /* ── Submit handler ── */
  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    hideError();

    if (!validateForm()) return;

    var submitBtn = document.getElementById('wsa-submit');
    var originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    var legalBusinessName = val('wsa-legal-business-name');
    var ownerName = val('wsa-owner-name');
    var businessType = val('wsa-business-type');
    var businessAddress = val('wsa-business-address');
    var businessCity = val('wsa-business-city');
    var businessState = val('wsa-business-state');
    var businessZip = val('wsa-business-zip');
    var businessPhone = val('wsa-business-phone');

    var shippingSame = shippingSameCheckbox ? shippingSameCheckbox.checked : true;
    var shippingAddress = shippingSame ? businessAddress : val('wsa-shipping-address');
    var shippingCity = shippingSame ? businessCity : val('wsa-shipping-city');
    var shippingState = shippingSame ? businessState : val('wsa-shipping-state');
    var shippingZip = shippingSame ? businessZip : val('wsa-shipping-zip');

    var billingContactName = val('wsa-billing-contact-name');
    var billingContactPhone = val('wsa-billing-contact-phone');
    var billingContactEmail = val('wsa-billing-contact-email');

    var orderingSame = orderingSameCheckbox ? orderingSameCheckbox.checked : false;
    var orderingContactName = orderingSame ? billingContactName : val('wsa-ordering-contact-name');
    var orderingContactPhone = orderingSame ? billingContactPhone : val('wsa-ordering-contact-phone');
    var orderingContactEmail = orderingSame ? billingContactEmail : val('wsa-ordering-contact-email');

    var paymentPreference = val('wsa-payment-preference');
    var accountTypeEl = formEl.querySelector('input[name="account_type"]:checked');
    var accountType = accountTypeEl ? accountTypeEl.value : '';
    var retailVolume = (accountType === 'Retail' || accountType === 'Both') ? val('wsa-retail-volume') : '';
    var bulkVolume = (accountType === 'Bulk' || accountType === 'Both') ? val('wsa-bulk-volume') : '';
    var taxExemptEl = formEl.querySelector('input[name="tax_exempt"]:checked');
    var taxExempt = taxExemptEl ? taxExemptEl.value : '';

    var referralSource = val('wsa-referral-source');
    var notes = val('wsa-notes');

    var utmSource = val('wsa-utm-source');
    var utmMedium = val('wsa-utm-medium');
    var utmCampaign = val('wsa-utm-campaign');
    var utmContent = val('wsa-utm-content');
    var utmTerm = val('wsa-utm-term');
    var referrerUrl = val('wsa-referrer');
    var submittedAt = new Date().toISOString();

    var orderingNameParts = orderingContactName.split(' ');
    var orderingFirstName = orderingNameParts[0] || '';
    var orderingLastName = orderingNameParts.slice(1).join(' ') || '';

    var profileAttrs = {
      email: orderingContactEmail,
      first_name: orderingFirstName,
      last_name: orderingLastName,
      organization: legalBusinessName,
      phone_number: toE164(orderingContactPhone) || undefined,
      properties: {
        wholesale_lead_type: businessType,
        wholesale_account_type: accountType,
        wholesale_status: 'application_submitted',
        wholesale_application_submitted_at: submittedAt,
        wholesale_payment_preference: paymentPreference,
        wholesale_retail_volume: retailVolume,
        wholesale_bulk_volume: bulkVolume,
        wholesale_tax_exempt: taxExempt,
        wholesale_billing_email: billingContactEmail,
        wholesale_billing_contact_name: billingContactName,
        wholesale_billing_contact_phone: billingContactPhone,
        wholesale_owner_name: ownerName,
        wholesale_business_phone: businessPhone,
        wholesale_shipping_address: shippingAddress,
        wholesale_shipping_city: shippingCity,
        wholesale_shipping_state: shippingState,
        wholesale_shipping_zip: shippingZip,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_term: utmTerm,
        referrer_url: referrerUrl
      },
      location: {
        address1: businessAddress,
        city: businessCity,
        region: businessState,
        zip: businessZip,
        country: 'US'
      }
    };

    if (!profileAttrs.phone_number) delete profileAttrs.phone_number;

    var payload1 = buildSubscriptionPayload(LIST_ID_NEW_ACCOUNTS, profileAttrs);
    var payload2 = buildSubscriptionPayload(LIST_ID_ORDERING_CONTACTS, profileAttrs);

    function showConfirmation() {
      formEl.setAttribute('hidden', '');
      var confirmation = document.getElementById('wsa-confirmation');
      if (confirmation) {
        var nameSpan = confirmation.querySelector('[data-first-name]');
        if (nameSpan) nameSpan.textContent = orderingFirstName;
        confirmation.removeAttribute('hidden');
      }

      var formArea = document.getElementById('wsa-form-area');
      if (formArea) formArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var eventProperties = {
      legal_business_name: legalBusinessName,
      owner_name: ownerName,
      business_type: businessType,
      business_address: businessAddress,
      business_city: businessCity,
      business_state: businessState,
      business_zip: businessZip,
      business_phone: businessPhone,
      shipping_address: shippingAddress,
      shipping_city: shippingCity,
      shipping_state: shippingState,
      shipping_zip: shippingZip,
      billing_contact_name: billingContactName,
      billing_contact_phone: billingContactPhone,
      billing_contact_email: billingContactEmail,
      ordering_contact_name: orderingContactName,
      ordering_contact_phone: orderingContactPhone,
      ordering_contact_email: orderingContactEmail,
      payment_preference: paymentPreference,
      account_type: accountType,
      retail_volume: retailVolume,
      bulk_volume: bulkVolume,
      tax_exempt: taxExempt,
      referral_source: referralSource,
      notes: notes,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_term: utmTerm,
      referrer_url: referrerUrl
    };
    var eventPayload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Wholesale Account Application' } } },
          profile: { data: { type: 'profile', attributes: { email: orderingContactEmail } } },
          properties: eventProperties
        }
      }
    };

    if (looksLikeBot()) return showConfirmation();

    var failures = [];
    function note(step, err) {
      var reason = step + ': ' + ((err && err.message) || String(err));
      failures.push(reason);
      if (IS_DEV) console.warn('Wholesale application fallback:', reason);
    }
    function subscribe(payload, label) {
      return postKlaviyo(SUBSCRIBE_URL, payload).catch(function (err) {
        note('subscribe ' + label, err);
        // Klaviyo refused it (4xx) with a phone on the profile: try once more without the phone.
        if (/^HTTP 4/.test(err && err.message) && profileAttrs.phone_number) {
          delete profileAttrs.phone_number;
          return postKlaviyo(SUBSCRIBE_URL, payload).catch(function (err2) { note('subscribe ' + label + ' without phone', err2); });
        }
      });
    }

    /* Step 1: both list subscriptions. Failures here never stop the application. */
    Promise.all([subscribe(payload1, 'new accounts'), subscribe(payload2, 'ordering contacts')])
      /* Step 2: the event (it creates the profile on its own if the subscriptions failed) */
      .then(function () {
        if (failures.length) eventProperties.submit_fallback_reason = failures.join(' | ');
        return postKlaviyo(EVENT_URL, eventPayload).then(function () { return 'klaviyo'; });
      })
      /* Step 3: Klaviyo unreachable, so send a backup copy through Shopify's contact form (info@) */
      .catch(function (err) {
        note('event', err);
        var lines = ['WHOLESALE ACCOUNT APPLICATION (backup copy: Klaviyo could not be reached from this visitor\'s browser)', ''];
        Object.keys(eventProperties).forEach(function (k) {
          if (k !== 'submit_fallback_reason' && eventProperties[k]) lines.push(k + ': ' + eventProperties[k]);
        });
        lines.push('', 'submit_fallback_reason: ' + failures.join(' | '), 'page: ' + location.href);
        return sendBackup('Wholesale account application (backup)', orderingContactName, orderingContactEmail, orderingContactPhone, lines)
          .then(function () { return 'backup'; });
      })
      .then(function (path) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'wholesale_application_submitted',
          submit_path: path,
          business_type: businessType,
          account_type: accountType,
          retail_volume: retailVolume,
          bulk_volume: bulkVolume
        });

        showConfirmation();
      })
      .catch(function (err) {
        note('backup', err);
        console.error('Wholesale form submission failed:', failures.join(' | '));
        var mailLines = Object.keys(eventProperties).filter(function (k) { return k !== 'submit_fallback_reason' && eventProperties[k]; })
          .map(function (k) { return k + ': ' + eventProperties[k]; });
        showError(
          'Sorry, your application didn\'t go through. <a href="' + mailtoLink('Wholesale account application', mailLines) + '">Email us your request</a> (it opens your email with everything filled in), or write to <a href="mailto:wholesale@magnoliacoffeeco.com">wholesale@magnoliacoffeeco.com</a> and we\'ll take it from there.'
        );
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      });
  });
  /* ── Back from a backup post: Shopify returns to this page with ?contact_posted=true ── */
  (function () {
    var pending = readBackupFlag();
    var posted = /[?&]contact_posted=true/.test(location.search);
    var backFromCheck = /[?&]form_type=contact/.test(location.search);
    if (!posted && backFromCheck && pending && pending.fields && pending.tries < 3) {
      // Back from Shopify's "not a robot" check: send the saved backup again.
      pending.tries += 1;
      try { sessionStorage.setItem(BACKUP_FLAG, JSON.stringify(pending)); } catch (e) {}
      submitBackupForm(pending.fields);
      return;
    }
    if (posted) {
      formEl.setAttribute('hidden', '');
      var confirmation = document.getElementById('wsa-confirmation');
      if (confirmation) {
        var nameSpan = confirmation.querySelector('[data-first-name]');
        if (nameSpan && pending && pending.name) nameSpan.textContent = pending.name.split(' ')[0];
        confirmation.removeAttribute('hidden');
      }
      var formArea = document.getElementById('wsa-form-area');
      if (formArea) formArea.scrollIntoView({ block: 'start' });
      if (pending) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'wholesale_application_submitted', submit_path: 'backup' });
      }
    } else if (pending) {
      // Shopify didn't accept the backup either
      var saved = pending.fields ? pending.fields['contact[body]'].split('\n') : [];
      showError(
        'Sorry, your application didn\'t go through. <a href="' + mailtoLink('Wholesale account application', saved) + '">Email us your request</a> (it opens your email with everything filled in), or write to <a href="mailto:wholesale@magnoliacoffeeco.com">wholesale@magnoliacoffeeco.com</a> and we\'ll take it from there.'
      );
    }
  })();
})();
